// extracted by mini-css-extract-plugin
export default {"userInitialButton":"UserInitialButton_userInitialButton__Qt0AK"};